import React from 'react';

class ColorFormatter extends React.PureComponent {
  render() {
    const { value } = this.props;
    return (
      <div
        style={{
          padding: '6px 2px',
          borderRadius: '5px',
          borderStyle: 'solid',
          borderWidth: '1px',
          backgroundColor: value,
        }}
      >
      </div>
    );
  }
}

export default ColorFormatter;
